import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {AuthenticationDetails, CognitoUser, CognitoUserPool} from 'amazon-cognito-identity-js';
import {environment} from '../../../../environments/environment';
import {MessageService} from '../../../shared/services/message.service';
import {throwError} from 'rxjs';

const COGNITO_APP_CLIENT_ID = environment.cognitoAppClientId;
const COGNITO_USER_POOL_ID = environment.cognitoUserPoolId;
const COGNITO_LOGIN_ENABLED = environment.cognitoLoginEnabled;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  loginInvalid = false;
  error = '';
  returnUrl!: string;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService
  ) {

    const errorMessage = this.router.getCurrentNavigation()?.extras?.state?.error;
    this.returnUrl = this.router.getCurrentNavigation()?.finalUrl?.queryParams?.returnUrl;
    if (errorMessage) {
      this.error = errorMessage;
    }

    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      if (this.returnUrl) {
        this.router.navigateByUrl(this.returnUrl)
          .catch(error => throwError(error));
      } else {
        this.router.navigateByUrl('/')
          .catch(error => throwError(error));
      }
    }
  }

  onSubmit(): void {
    this.loginInvalid = false;

    if (this.form.valid) {
      const username = this.form.get('username')?.value;
      const password = this.form.get('password')?.value;

      if (COGNITO_LOGIN_ENABLED && username !== 'wf-admin@yopmail.com') {
        const authenticationDetails = new AuthenticationDetails({
          Username: this.form.get('username')?.value,
          Password: this.form.get('password')?.value,
        });

        const userPool = new CognitoUserPool({
          UserPoolId: COGNITO_USER_POOL_ID,
          ClientId: COGNITO_APP_CLIENT_ID
        });
        const userData = { Username: username, Pool: userPool };
        const cognitoUser = new CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: (result) => {
            this.doApiLogin(username, '', result.getIdToken().getJwtToken());
          },
          onFailure: (err) => {
            this.messageService.showMessage(err.message, 'error');
          },
        });
      } else {
        this.doApiLogin(username, password);
      }

    }
  }

  private doApiLogin(username: string, password: string, cognitoToken?: string): void {
    this.authService.login(username, password, cognitoToken)
      .subscribe(
        () => {
          this.authService.$onLogin.next(username);
          this.router.navigate([this.returnUrl ? this.returnUrl : '']);
        },
        () => this.loginInvalid = true
      );
    this.router.navigate([this.returnUrl ? this.returnUrl : '']);
  }
}
